import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { formatViews } from "./states";

export default function RecordingCard({ rec, index = 0 }) {
  return (
    <Link to={`/recording/${rec.id}`} data-testid={`recording-card-${rec.id}`}
      className="group card-copper rounded-xl overflow-hidden fade-up" style={{ animationDelay: `${Math.min(index * 0.04, 0.4)}s` }}>
      <div className="relative aspect-video overflow-hidden bg-[#1A1A22]">
        {rec.cover_image && (
          <img src={rec.cover_image} alt={rec.title} loading="lazy"
            className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 rounded-full copper-btn flex items-center justify-center"><Play size={18} className="ml-0.5" /></span>
        </div>
        {(rec.has_tracklist || (rec.tracklist && rec.tracklist.length > 0)) && (
          <span className="absolute top-2 right-2 mono-label text-[#0A0A0C] bg-[#E8552A] rounded px-1.5 py-0.5 text-[0.6rem]">TRACK ID</span>
        )}
        {rec.premium_locked && (
          <span data-testid={`premium-badge-${rec.id}`} className="absolute top-2 left-2 mono-label text-[#F4F4F5] bg-[#0A0A0C]/80 border border-[#E8552A]/60 rounded px-1.5 py-0.5 text-[0.6rem]">PREMIUM</span>
        )}
      </div>
      <div className="p-3">
        <p className="font-display font-semibold text-sm text-[#F4F4F5] truncate group-hover:text-[#E8552A] transition-colors">{rec.title}</p>
        <div className="flex items-center justify-between mt-1.5">
          <span className="mono-label text-[#71717A] truncate">{rec.dj_name}</span>
          <span className="mono-label text-[#71717A]">{formatViews(rec.views)} views</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {(rec.genres || []).slice(0, 2).map((g) => (
            <span key={g} className="text-[0.6rem] font-mono uppercase tracking-wide text-[#A1A1AA] border border-[#27272A] rounded px-1.5 py-0.5">{g}</span>
          ))}
        </div>
      </div>
    </Link>
  );
}
